import axios from 'axios'
import { API_BASE_URL } from '../globalVar'

let baseUrl = API_BASE_URL
//let baseUrl = process.env.VUE_APP_API_BASE_URL

export const formApiService = {
    getFormUserFilterPagenated,
    getFormUser,
    getFormUserLoginHistory,
    getFormUserLoginHistoryEx,
    formUserExists,
    formUserCreate,
    formUserAssignToClaim,
    formUserCreateAssignToClaim
}

function getFormUserFilterPagenated(payload) {
    return axios.post(baseUrl + '/api/admin/v1/form/formusers', payload)
}

function getFormUser(payload) {
    return axios.get(baseUrl + '/api/admin/v1/form/formuser/' + payload)
}

function getFormUserLoginHistory(payload) {
    return axios.get(baseUrl + '/api/admin/v1/form/formuser/loginhistory/' + payload)
}

function getFormUserLoginHistoryEx(userId, pageNumber) {
    return axios.get(baseUrl + '/api/admin/v1/form/formuser/loginhistory/' + userId + '/' + pageNumber)
}

function formUserExists(payload) {
    return axios.get(baseUrl + '/api/admin/v1/form/formuser/exists/' + payload.resellerId + '/' + payload.emailAddress)
}

function formUserCreate(payload) {
    return axios.get(baseUrl + '/api/admin/v1/form/formuser/create/' + payload.resellerId + '/' + payload.emailAddress)
}

function formUserAssignToClaim(payload) {
    return axios.post(baseUrl + '/api/admin/v1/form/formuser/assigntoclaim/', payload)
}

function formUserCreateAssignToClaim(payload) {
    return axios.post(baseUrl + '/api/admin/v1/form/formuser/createassigntoclaim/', payload)
}